import "@atg-shared/micro-frontend/setPublicPath";
import {initLogger} from "@atg-shared/log";
import {configureStoreForAuthentication} from "@atg-shared/auth";
import {initialiseLanguage} from "@atg-shared/language";
import {configureEmotionCache} from "atg-emotion-cache";
import {store as casinoStore} from "./store";

initLogger({
    application: "atg-web-casino",
    logLevel: process.env.NODE_ENV !== "production" ? "info" : "warn",
});
configureStoreForAuthentication(casinoStore);
configureEmotionCache("casino");

initialiseLanguage(async (locale) => {
    const {messages} = await import(
        /* webpackChunkName: "i18n" */ `../locales/${locale}/messages.po`
    );
    return messages;
});

export const App = () => import(/* webpackChunkName: "App" */ "./components/App/App");

export const SideMenu = () =>
    import(/* webpackChunkName: "SideMenu" */ "./components/SideMenu/SideMenu");
